import { render, staticRenderFns } from "./InboxRightSidebar.vue?vue&type=template&id=4b0142c0&scoped=true&"
import script from "./InboxRightSidebar.vue?vue&type=script&lang=js&"
export * from "./InboxRightSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0142c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0142c0')) {
      api.createRecord('4b0142c0', component.options)
    } else {
      api.reload('4b0142c0', component.options)
    }
    module.hot.accept("./InboxRightSidebar.vue?vue&type=template&id=4b0142c0&scoped=true&", function () {
      api.rerender('4b0142c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamInbox/InboxRightSidebar.vue"
export default component.exports